export const nearByGymLocationSearchRadius = 200; // kms
export const visibleNearByGymsLimit = 3; // number of nearby gyms to show on UI.
